class InfoAccordion extends HTMLElement {
  /** @type {(event: Event) => void} */
  _boundSectionLoad;

  constructor() {
    super();
    this._boundSectionLoad = this._onSectionLoad.bind(this);
  }

  connectedCallback() {
    this.addEventListener('click', this._onClick.bind(this));
    document.addEventListener('shopify:section:load', this._boundSectionLoad);
    this._initDefaults();
  }

  disconnectedCallback() {
    document.removeEventListener('shopify:section:load', this._boundSectionLoad);
  }

  _initDefaults() {
    this.querySelectorAll('.info-accordion__item').forEach((item) => {
      if (/** @type {HTMLElement} */ (item).dataset.openDefault === 'true') {
        this._openItem(/** @type {HTMLElement} */ (item));
      }
    });
  }

  /** @param {MouseEvent} event */
  _onClick(event) {
    const trigger = /** @type {HTMLElement} */ (event.target).closest(
      '.info-accordion__trigger'
    );
    if (!trigger) return;

    const item = /** @type {HTMLElement | null} */ (
      trigger.closest('.info-accordion__item')
    );
    if (!item) return;

    const isOpen = item.dataset.open === 'true';

    this.querySelectorAll('.info-accordion__item').forEach((el) => {
      this._closeItem(/** @type {HTMLElement} */ (el));
    });

    if (!isOpen) {
      this._openItem(item);
    }
  }

  /** @param {HTMLElement} item */
  _openItem(item) {
    item.dataset.open = 'true';
    const trigger = item.querySelector('.info-accordion__trigger');
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
  }

  /** @param {HTMLElement} item */
  _closeItem(item) {
    item.dataset.open = 'false';
    const trigger = item.querySelector('.info-accordion__trigger');
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
  }

  /** @param {Event} event */
  _onSectionLoad(event) {
    if (!this.isConnected) return;
    this.querySelectorAll('.info-accordion__item').forEach((item) => {
      this._closeItem(/** @type {HTMLElement} */ (item));
    });
    this._initDefaults();
  }
}

if (!customElements.get('info-accordion')) {
  customElements.define('info-accordion', InfoAccordion);
}
